import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import importedAppConfig from '@/appConfig';
import { SAuthForm } from '@slg/web-customer-shared';
import { useStore, useVm, useGlobalErrorDialog } from '@/composables';


const __default__ = {
  name: 'AuthForm',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isAuthPage: {
    type: Boolean,
    default: true,
  },
  isDisplayedImageAndTitle: {
    type: Boolean,
    default: true,
  },
},
  emits: ['onSignInSuccess'],
  setup(__props, { emit }) {




const store = useStore();
const vm = useVm();
const { setGlobalError } = useGlobalErrorDialog();
const appConfig = importedAppConfig;
const getLocation = computed(() => store.getters['auth/getLocation']);

function setGlobalLoading(isLoading: boolean) {
  store.commit('common/setGlobalLoading', isLoading);
}

function setAuthToken(authToken: string) {
  if (localStorage.getItem('authToken') !== authToken) {
    store.commit('auth/clearAuthTokenAndProfileInfo');
    store.commit('auth/setAuthToken', authToken);
  }
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}

async function redirect() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
  vm.$root.$emit('auth-success');
  await emit('onSignInSuccess');
}

return { __sfc: true,emit, store, vm, setGlobalError, appConfig, getLocation, setGlobalLoading, setAuthToken, populateUserProfileInfo, redirect, SAuthForm }
}

})